module.exports = __webpack_public_path__ + "img/1791993842927.841a5a4a.png";